import { useMutation } from '@tanstack/react-query';
import { signUpMutationFunction } from '@/modules/Auth/queries/signUp/signUpMutationFunction.ts';

const useSignUpRequest = () => {
  return useMutation({
    mutationFn: signUpMutationFunction,
    meta: {
      error: false,
    },
  });
};

export default useSignUpRequest;
